import { IPayU } from '../../types/payu'
import { IBill } from '../../types/bills'
import { ICity } from '../../types/cities'
import { IUser } from '../../types/models'
import { getUser } from '../../services/user'
import { useLocation } from 'react-router-dom'
import { IService } from '../../types/services'
import { saveBill } from '../../services/bills'
import { ITemplate } from '../../types/templates'
import { getDataPayU } from '../../services/payu'
import { getCities } from '../../services/cities'
import Container from '@material-ui/core/Container'
import { IDepartment } from '../../types/departments'
import { makeStyles } from '@material-ui/core/styles'
import { useSession } from '../../context/SessionContext'
import UserAppBar from '../DocEngine/UserPanel/UserAppBar'
import { getDepartments } from '../../services/departments'
import { DocumentTypesMap, ROLES } from '../../config/user'
import { LegacyRef, useEffect, useRef, useState } from 'react'
import Alert, { ActionsOptType } from '../../components/Alert'
import { createSignature, numberFormat } from '../../utils/functions'
import SuperUserAppBar from '../DocEngine/SuperUserPanel/SuperUserAppBar'
import { Button, Grid, MenuItem, TextField, Typography } from '@material-ui/core'

// Define styles for the component
const useStyles = makeStyles((theme) => ({
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    color: '#FFFFFF',
    backgroundColor: theme.palette.secondary.dark,
    width: '25rem',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(2),
    width: '25rem',
  },
  helperText: {
    margin: 0,
    fontSize: '0.9rem',
    width: '100%',
    padding: '1vh',
  },
}))

/**
 * Custom `Payment` component declaration.
 * @return Payment
 */
const Payment = (): JSX.Element => {
  const paymentForm: LegacyRef<HTMLFormElement> = useRef<HTMLFormElement>(null)
  const classes = useStyles()
  const { user } = useSession()
  const location: any = useLocation()
  const template = location.state.template as ITemplate
  const [departments, setDepartments] = useState<IDepartment[]>()
  const [cities, setCities] = useState<ICity[]>()
  const currentService = location.state.currentService as IService
  const [billId, setBillId] = useState<string>()
  const [payU, setPayU] = useState<IPayU>()
  const [alertOptions, setAlertOptions] = useState<ActionsOptType>({
    message: null,
    type: null,
    open: false,
  })
  const [userObj, setUserObj] = useState<IUser>({
    user_name: user?.username || '',
  })
  const [billObj, setBillObj] = useState<IBill>({
    users_id: user?.id || '',
    services_id: currentService.id || '',
    templates_id: template.id || '',
    state: '-',
    value: template.price || 0
  })
  const [random, setRandom] = useState<string>()
  const [signature, setSignature] = useState<string>()
  
  // Load user data, payu data and create randomcode
  useEffect(() => {
    const loadUser = async () => {
      try {
        const _user = await getUser()
        if (_user) 
        {
          setUserObj({ ...userObj, ..._user.data })
          setBillObj({ ...billObj, 
                      email: _user.data.email || '',
                      document_type: _user.data.document_type_id || '',
                      document: _user.data.document || '',
                      phone: _user.data.phone || '',
                      departments_id: _user.data.departments_id || 0,
                      cities_id: _user.data.city_id || 0
                    })
        loadPayU()    
        setRandom(createRandomCode())                
        }
      } catch (error) {
        return error;
      }
    }
    loadUser()
  }, [])
  
  // get signature
  useEffect(() => {
    if(payU && template.price && random)
    {
      setSignature(createSignature(payU, template.price, random))
    }
  }, [payU, random])

  // get payu data
  const loadPayU = async () => {
    const { data } = await getDataPayU()
    if (data) setPayU(data)
  }

  // Load list departments
  useEffect(() => {
    const fetchData = async () => {
      const { data, error } = await getDepartments()
      if (data) setDepartments(data)
      if (error) setAlertOptions({ message: error, open: true, type: 'error' })
    }
    if (!departments) {
      fetchData()
    }
  }, [])

  // Load list cities by department id
  useEffect(() => {
    const fetchData = async () => {
      if(userObj && userObj.departments_id)
      {
        const { data, error } = await getCities(userObj.departments_id)
        if (data) setCities(data)
        if (error) setAlertOptions({ message: error, open: true, type: 'error' })
      }
    }
    fetchData()
  }, [userObj])

  // get random code for signature
  const  createRandomCode = () => {
    const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let response = '';
    const charactersLength = characters.length;
    for ( let i = 0; i < 15; i ++ ) {
        response += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return response;
  }

  /**
   * This method is used to save bill data
   * @return {Void}
  */
  const onSubmit = async () => {
    if(billObj.users_id && billObj.templates_id && billObj.services_id && payU)
    {
      if(billObj.name && billObj.document_type && billObj.document && billObj.departments_id && billObj.cities_id && billObj.email && billObj.phone)
      {
        const { data, error } = await saveBill(billObj)
        if (data) {
          setBillId(data.data)
          setAlertOptions({
            message: 'A continuación seras redirigido a PAYU',
            open: true,
            type: 'info',
          })
          document.forms.namedItem("pagosPayU")?.submit()
        }
        if (error) setAlertOptions({ message: error, open: true, type: 'error' })
      }
      else
      {
        setAlertOptions({
          message: 'Por favor ingrese toda la información solicitada en el formulario.',
          open: true,
          type: 'error',
        })
      }
    }
    else
    {
      setAlertOptions({
        message: 'No es posible generar su factura, por favor vuelva a "Mis Solicitudes" y seleccione el documento a pagar.',
        open: true,
        type: 'error',
      })
    }
  }

  return (
    <div>
      <Alert alertOptions={alertOptions} setAlertOptions={setAlertOptions} />
      <div>
        {user?.role === ROLES.USER && <UserAppBar />}
        {user?.role === ROLES.SUPER_USER && <SuperUserAppBar />}
      </div>
      <Container className={classes.cardGrid} maxWidth="md">
        <Typography
          component="p"
          variant="body1"
          align="center"
          color="textPrimary"
          gutterBottom
          style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1rem' }}
        >
          ¡Ingresa la siguiente información para generar tu factura! 
        </Typography>

        {/* load bill data and get bill data into textfields */}
        <Grid container spacing={1} justifyContent={'center'} alignItems={'center'}>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              className={classes.textField}
              style={{ width: '100%', marginTop: '0.6rem' }}
              id={`template_name`}
              label="Nombre de la plantilla"
              disabled={true}
              value={currentService.service_data?.name || ''}
              variant="outlined"
              FormHelperTextProps={{
                className: classes.helperText,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              className={classes.textField}
              style={{ width: '100%', marginTop: '0.6rem' }}
              id={`name`}
              label="Nombre / Razón social"
              variant="outlined"
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _bill = { 
                  ...billObj, 
                  name: event.target.value 
                }
                setBillObj({ ..._bill })
              }} 
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <TextField
              className={classes.textField}
              style={{ width: '100%', marginTop: '0.6rem' }}
              id={`email`}
              label="Correo"
              value={userObj.email || ''}
              variant="outlined"
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _user = { ...userObj, email: event.target.value }
                setUserObj({ ..._user })
                const _bill = { 
                  ...billObj, 
                  email: event.target.value
                }
                setBillObj({ ..._bill })
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <TextField
              className={classes.textField}
              style={{ width: '100%', marginTop: '0.6rem' }}
              id="document_type"
              select
              label={'Tipo de documento'}
              value={userObj.document_type_id || ''}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _user = { ...userObj, document_type_id: Number(event.target.value) }
                setUserObj({ ..._user })
                const _bill = { 
                  ...billObj, 
                  document_type: Number(event.target.value)
                }
                setBillObj({ ..._bill })
              }}
              variant="outlined"
              // error={inputError.error}
              // helperText={inputError.error ? inputError.label : input.info}
              FormHelperTextProps={{
                className: classes.helperText,
              }}
            >
              {Array.from(DocumentTypesMap.values()).map(
                (input, index: number) => (
                  <MenuItem key={index} value={input.id}>
                    {input.name}
                  </MenuItem>
                )
              )}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <TextField
              className={classes.textField}
              style={{ width: '100%', marginTop: '0.6rem' }}
              id={`document`}
              label="Número de documento"
              value={userObj.document || ''}
              variant="outlined"
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _user = { ...userObj, document: event.target.value }
                setUserObj({ ..._user })
                const _bill = { 
                  ...billObj, 
                  document: _user.document
                }
                setBillObj({ ..._bill })
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <TextField
              className={classes.textField}
              style={{ width: '100%', marginTop: '0.6rem' }}
              id={`phone`}
              label="Télefono"
              value={userObj.phone || ''}
              variant="outlined"
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _user = { ...userObj, phone: event.target.value }
                setUserObj({ ..._user })
                const _bill = { 
                  ...billObj, 
                  phone: event.target.value
                }
                setBillObj({ ..._bill })
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <TextField
              className={classes.textField}
              style={{ width: '100%', marginTop: '0.6rem' }}
              id={`department`}
              select
              label="Departamento"
              value={userObj.departments_id ||''}
              variant="outlined"
              // helperText={''}
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _user = { ...userObj, departments_id: Number(event.target.value) }
                setUserObj({ ..._user })          
                const _bill = { 
                  ...billObj, 
                  departments_id: Number(event.target.value)
                }
                setBillObj({ ..._bill })         
                const fetchData = async () => {
                  const { data, error } = await getCities(_bill.departments_id)
                  if (data) setCities(data)
                  if (error) setAlertOptions({ message: error, open: true, type: 'error' })
                }
                fetchData()
              }}
            >
              {departments && ( Array.from(departments.values()).map((input, index: number) => (
                <MenuItem key={index} value={input.id}>
                  {input.name}
                </MenuItem>
              )))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <TextField
              className={classes.textField}
              style={{ width: '100%', marginTop: '0.6rem' }}
              id={`city`}
              select
              label="Municipio"
              value={userObj.city_id || ''}
              variant="outlined"
              // helperText={''}
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _user = { ...userObj, city_id: Number(event.target.value) }
                setUserObj({ ..._user })
                const _bill = { 
                  ...billObj, 
                  cities_id: event.target.value
                }
                setBillObj({ ..._bill })
              }}
            >
              {cities && Array.from(cities.values()).map((input, index: number) => (
                <MenuItem key={index} value={input.id}>
                  {input.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>     
          <Grid item xs={12} sm={12} md={12} lg={3}>
            <TextField
              className={classes.textField}
              style={{ width: '100%', marginTop: '0.6rem' }}
              id={`value`}
              label="Valor a pagar"
              disabled={true}
              value={numberFormat(Number(template.price))}
              variant="outlined"
              FormHelperTextProps={{
                className: classes.helperText,
              }}
            />
          </Grid>
        </Grid>
        <Typography
          component="p"
          variant="body1"
          align="center"
          color="textSecondary"
          gutterBottom
          style={{ fontSize: '1rem', fontWeight: 'normal', marginTop: '0.7rem' }}
        >
          Al presionar PAGAR serás direccionado a PayU, donde pordrás cancelar con tarjeta o en efectivo. Si cancelas en efectivo, te rogamos confirmarnos el pago vía Whatsapp.
        </Typography>
        <Typography
          component="p"
          variant="body1"
          align="center"
          color="textSecondary"
          gutterBottom
          style={{ fontSize: '1rem', fontWeight: 'normal', marginTop: '0.5rem' }}
        >
          !Todos los pagos realizados en esta plataforma tienen incluido el impuesto del IVA!
        </Typography>
        <Button
          style={{ marginTop: '1.5rem'}}
          type="submit"
          fullWidth
          variant="contained"
          className={classes.submit}
          onClick={() => onSubmit()}
        >
          Pagar
        </Button>

        {/* create form needed to send data to payu */}
        {payU && user && (
        <form ref={paymentForm} id='pagosPayU' method='post' action={payU.checkout_url}>
          <input name='merchantId'        type='hidden'  value={payU.merchant_id} />
          <input name='accountId'         type='hidden'  value={payU.account_id}/>
          <input name='description'       type='hidden'  value={`Compra de documento ${template.name}`}/>
          <input name='referenceCode'     type='hidden'  value={random}/>
          <input name='amount'            type='hidden'  value={template.price}/>
          <input name='tax'               type='hidden'  value='0'/>
          <input name='taxReturnBase'     type='hidden'  value='0'/>
          <input name='currency'          type='hidden'  value={payU.currency}/>
          <input name='signature'         type='hidden'  value={signature}/>
          <input name='test'              type='hidden'  value='0'/>
          <input name='buyerFullName'     type='hidden'  value={billObj.name}/>
          <input name='payerDocument'     type='hidden'  value={billObj.document}/>
          <input name='buyerEmail'        type='hidden'  value={billObj.email}/>
          <input name='payerMobilePhone'  type='hidden'  value={billObj.phone}/>
          <input name='extra1'            type='hidden'  value={user.id}/>
          <input name='extra2'            type='hidden'  value={currentService.id}/>
          <input name='extra3'            type='hidden'  value={billId}/>
          <input name='responseUrl'       type='hidden'  value=''/>
          <input name='confirmationUrl'   type='hidden'  value={process.env.REACT_APP_JUSTI_API_URL + '/payment/prueba'}/>
          {/* <input name='confirmationUrl'   type='hidden'  value='https://.ngrok.io/payment/prueba'/> */}
        </form>
        )}
      </Container>
    </div>
  )
}

export default Payment